module.exports = __webpack_public_path__ + "static/img/valery.f856b74.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/news/valery.png
// module id = pEmC
// module chunks = 1